import _ from 'lodash';
import { observable, action } from 'mobx';

let currentKey = 0;
function nextKey() {
  currentKey++;
  return currentKey;
}

export type MessageStyle =
  | 'primary'
  | 'default'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info';

export interface Message {
  //bootstrap styles: primary, default, success, warning, danger
  style: MessageStyle;
  text: string;
}

export interface KeyedMessage extends Message {
  key: number;
}

export class MessageStore {
  @observable messages: KeyedMessage[] = [];

  @action
  handleMessage(message: Message) {
    const fullMessage = { ...message, key: nextKey() };
    this.messages.push(fullMessage);
    setTimeout(() => this.removeMessage(fullMessage), 7000);
  }

  @action
  clearMessages() {
    this.messages = [];
  }

  @action.bound
  private removeMessage(message: KeyedMessage) {
    this.messages = this.messages.filter(msg => msg.key != message.key);
  }
}

export const messageStore = new MessageStore();

export interface DialogState {
  dialogs: DialogContent[];
}

export class DialogStore {
  @observable dialogs: DialogContent[] = [];

  @action
  addDialog(dialog: DialogContent) {
    this.dialogs.push(dialog);
  }

  @action
  closeFirstDialog() {
    this.dialogs.shift();
  }
}

export const dialogStore = new DialogStore();
